import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import FocusTrapper from 'ember-focus-trapper/components/focus-trapper';
import { pluralize } from 'ember-inflector';
import ModalDialog from 'garaje/components/ui/classic/modal-dialog';

interface DiscardSpreadsheetConfirmationSignature {
  Args: {
    rowCount: number;
    yes: () => void;
    no: () => void;
  };
}

export default <template>
  <ModalDialog
    @clickOutsideToClose={{false}}
    @targetAttachment="center"
    @translucentOverlay={{true}}
    @containerClass="ember-modal-dialog--discard-spreadsheet-confirmation !translate-y-0 !-translate-x-1/2 "
  >
    <FocusTrapper>
      <div data-test-spreadsheet-modal-discard-confirm class="p-8">
        <h3>Are you sure you want to discard this&nbsp;list?</h3>

        <p class="my-4">
          All the details you've entered about
          {{pluralize @rowCount "additional visitor"}}
          will be&nbsp;lost.
        </p>

        <div class="mt-8 flex items-center justify-end flex-none">
          <button
            type="button"
            class="ml-2 float-right btn btn--small btn--outline"
            {{on "click" @no}}
            data-test-spreadsheet-modal-discard-confirm-no
          >
            Go back
          </button>

          <button
            type="button"
            class="btn ml-4 btn--small btn--brand"
            {{on "click" @yes}}
            data-test-spreadsheet-modal-discard-confirm-yes
          >
            Yes, discard this list
          </button>
        </div>
      </div>
    </FocusTrapper>
  </ModalDialog>
</template> satisfies TOC<DiscardSpreadsheetConfirmationSignature>;
